import React, { useEffect } from 'react';
import { IonHeader, IonToolbar } from '@ionic/react';
import { useMobileSettings } from '@projectK/context/MobileContextProvider';
import { BackButton } from '@projectK/ReUseFunctions';
import { Capacitor } from '@capacitor/core';
import PropTypes from 'prop-types';

const IonicHeader = ({ GracePeriodBanner }) => {
  const fullUrl = window.location.href;
  const parsedUrl = new URL(fullUrl);
  const pathName = parsedUrl?.pathname;
  const parts = pathName.split('/');
  const { mobileMode } = useMobileSettings();
  const iOS = Capacitor.getPlatform() === 'ios';

  useEffect(() => {
    if (GracePeriodBanner) {
      document.body.classList.add('has-grace-banner');
    } else {
      document.body.classList.remove('has-grace-banner');
    }

    return () => {
      document.body.classList.remove('has-grace-banner');
    };
  }, [GracePeriodBanner]);

  return (
    <IonHeader mode={mobileMode}>
      <IonToolbar
        style={{
          '--background': '#fff',
          '--min-height': iOS ? '70px' : '30px',
        }}
      >
        <BackButton parts={parts} />
      </IonToolbar>

      {GracePeriodBanner}
    </IonHeader>
  );
};

export default IonicHeader;

IonicHeader.propTypes = {
  GracePeriodBanner: PropTypes.any,
};